import styled from "@emotion/styled";
import { Box, Typography, Button, Chip } from "@mui/material";

export const DashboardContainer = styled(Box)`
  display: flex;
  flex-direction: column;
  height: 100%;
  overflow: auto;
`;

export const DashboardHeader = styled(Box)`
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 24px;
`;

export const DashboardTitle = styled(Typography)`
  font-size: 32px;
  font-weight: 700;
  color: #1a1a1a;
`;

export const HeaderControls = styled(Box)`
  display: flex;
  align-items: center;
  gap: 16px;
`;

export const StartSessionButton = styled(Button)`
  background-color: #ffb800;
  color: white;
  font-weight: 600;
  padding: 12px 24px;
  border-radius: 8px;
  text-transform: none;
  font-size: 16px;

  &:hover {
    background-color: #e6a600;
  }
`;

export const DashboardContent = styled(Box)`
  display: flex;
  flex-direction: column;
  gap: 24px;
  overflow: auto;
`;

export const MainContent = styled(Box)`
  display: flex;
  flex-direction: column;
  gap: 24px;
  min-width: 0;
  overflow: auto;
  width: 100%;
`;

export const RightPanel = styled(Box)`
  width: 320px;
  display: flex;
  flex-direction: column;
  gap: 24px;
  flex-shrink: 0;
`;

export const ProviderChip = styled(Chip)`
  margin: 4px;

  &.MuiChip-root {
    border-radius: 16px;
  }
`;

export const LoadingContainer = styled(Box)`
  display: flex;
  justify-content: center;
  align-items: center;
  padding: 48px;
`;

export const ErrorContainer = styled(Box)`
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  padding: 48px;
  text-align: center;
`;

export const ErrorText = styled(Typography)`
  color: #d32f2f;
  margin-bottom: 16px;
`;

export const RetryButton = styled(Button)`
  text-transform: none;
`;

export const SummaryCardsContainer = styled(Box)`
  display: flex;
  gap: 16px;
  margin-bottom: 24px;
  flex-wrap: nowrap;
`;

export const SummaryCard = styled(Box)`
  display: flex;
  align-items: center;
  gap: 12px;
  padding: 16px;
  background: white;
  border-radius: 8px;
  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.1);
  border: 1px solid #e0e0e0;
  flex: 1;
  min-width: 0;
`;

export const SummaryCardIcon = styled(Box)<{ color: string }>`
  width: 40px;
  height: 40px;
  border-radius: 8px;
  background-color: ${(props) => props.color}20;
  display: flex;
  align-items: center;
  justify-content: center;
  color: ${(props) => props.color};
  font-size: 20px;
`;

export const SummaryCardNumber = styled(Typography)`
  font-size: 24px;
  font-weight: 700;
  color: #1a1a1a;
  line-height: 1;
`;

export const SummaryCardLabel = styled(Typography)`
  font-size: 14px;
  color: #666;
  margin-top: 4px;
`;

export const FeedPanelsContainer = styled(Box)`
  padding: 16px 8px 16px 16px;
  border-radius: 12px;
  height: 100%;
  background: #e8ecf4;
  display: flex;
  flex-direction: column;
`;

export const FeedPanelDivider = styled(Box)`
  height: 1px;
  background-color: rgba(255, 255, 255, 0.2);
  margin: 8px 0;
`;

export const DashboardMainContent = styled(Box)`
  display: flex;
  gap: 24px;
  overflow: auto;
`;
